export default "__VITE_ASSET__Doh1W1zC__"